import { FC, PropsWithChildren, useEffect } from 'react';

import { useExchangeToken, useGetTokenExpiration } from 'app/api/hooks/core/v1/auth/user';
import LoadingScreen from 'app/pages/shared/LoadingScreen';
import { useAuthState } from 'app/state/AuthContext/hooks';
import { nowInSeconds } from 'app/utils/lib/dates';

import SessionChecker from './SessionChecker';

// Component Definition
const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    tokenData,
  } = useAuthState();

  const { isFetched, tokenExp } = useGetTokenExpiration();

  const {
    mutate: exchangeToken,
  } = useExchangeToken();

  useEffect(() => {
    if (tokenExp > nowInSeconds() && !tokenData) {
      exchangeToken(undefined);
    }
  },
  [
    exchangeToken,
    tokenData,
    tokenExp,
  ]);

  if (!isFetched) {
    return <LoadingScreen />;
  }

  if (tokenExp > 0 && !tokenData) {
    return <LoadingScreen />;
  }

  return (
    <SessionChecker>
      {children}
    </SessionChecker>
  );
};

export default AuthProvider;
